import { useAuth } from '../../hooks';
import styles from './Header.module.css';

/**
 * Header Component
 * 
 * Top header bar with user info and logout.
 */

interface HeaderProps {
  title?: string;
  onMenuClick?: () => void;
}

export default function Header({ title, onMenuClick }: HeaderProps) {
  const { user, logout, isSupportOnly } = useAuth();

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <button 
          className={styles.menuButton} 
          onClick={onMenuClick}
          aria-label="Toggle menu"
        >
          <span className={styles.menuIcon}>☰</span>
        </button>
        {title && <h1 className={styles.title}>{title}</h1>}
      </div>

      <div className={styles.right}>
        <div className={styles.user}>
          <span className={styles.userEmail}>{user?.email}</span>
          {user?.is_superuser && (
            <span className={styles.badge}>Superuser</span>
          )}
          {user?.is_staff && !user?.is_superuser && (
            <span className={styles.badge}>Staff</span>
          )}
          {isSupportOnly && (
            <span className={styles.badge}>Support</span>
          )}
        </div>
        <button onClick={logout} className={styles.logoutButton}>
          Sign Out
        </button>
      </div>
    </header>
  );
}

